import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';


const orgEndpointInsert = '/api/firma';

const api = axios.create({
    baseURL: config.baseUrl,
});

api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


export const getFirmaElectronica = async (rutaFirma) => {
    try {
        const response = await api.get(`${orgEndpointInsert}`, {
            params: {
                rutaFirma: rutaFirma
            }
        });
        return response.data.data;
    } catch (error) {
        console.error('Error al obtener la firma electrónica:', error);
        throw error;
    }
};

